import React from "react";
import { Link } from "gatsby";
import AnchorLink from "react-anchor-link-smooth-scroll";
import Logo from "../../svg/logo.svg";

function Menu(props) {
  const { menus, showNav, isSubPage } = props;

  return (
    <>
      <h2 key="Logo" className="logo">
        <Link to="/">
          <Logo />
        </Link>
      </h2>
      {showNav && (
        <>
          <nav className="main-nav" data-testid="mainMenu--nav">
            {!menus
              ? null
              : menus.menuitems.map((item, index) => (
                  isSubPage ?
                    <Link key={index} to={`/#${item.url}`} data-testid={`mainMenu--navItem--${item.name}`}>
                      {item.name}
                    </Link>
                   :
                    <AnchorLink key={index} href={`#${item.url}`} data-testid={`mainMenu--navItem--${item.name}`}>
                      {item.name}
                    </AnchorLink>
              )
                )}
          </nav>
          <Link to="/clinics">
            <button className="button outline notdienst-suche">Info für Kliniken</button>
          </Link>
        </>
      )}
    </>
  );
}

export default Menu;
